import React from 'react';
import './slider-foamstop-pu-eggcrate.css';
import Eggcrate1 from '../../images/egg1.webp';
import Eggcrate2 from '../../images/egg1.webp';
function slider() {
	return (
	  
	<>
	<div id="slider-foamstop-pu-eggcrate">
		<div id="carouselExampleIndicators6" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators6" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators6" data-slide-to="1"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Eggcrate1} alt="Eggcrate1" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>EGGCRATE DESIGN</h1>
					</div>
				</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Eggcrate2} alt="Eggcrate2" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>EGGCRATE DESIGN</h1>
					</div>
				</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators6" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators6" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;